import React from 'react';
import withAnimation from '../../../hooks/withAnimation';

const HowToManage = ({ serviceName = "", management = [] }) => {
  // Divide management data into two columns
  const midIndex = Math.ceil(management.length / 2);
  const firstColumn = management.slice(0, midIndex);
  const secondColumn = management.slice(midIndex);

  return (
    <section className="container bg-white mx-auto px-4 py-8">
      <h2 className="text-3xl text-primary pb-4 font-bold text-center mb-8 lg:text-4xl">
        How to Manage {serviceName}
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 m-2 lg:m-0">
        {/* First Column */}
        <div>
          {firstColumn.map((item, index) => (
            <div key={index} className="mb-6">
              <h3 className="text-2xl font-bold mb-4">{item.title}</h3>
              <p className="text-gray-700 text-justify">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Second Column */}
        <div>
          {secondColumn.map((item, index) => (
            <div key={index} className="mb-6">
              <h3 className="text-2xl font-bold mb-4">{item.title}</h3>
              <p className="text-gray-700 text-justify">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default withAnimation(HowToManage);